export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-3">
          联系我们
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          有任何问题或建议？欢迎通过以下方式联系爱豆影视团队
        </p>
        <div className="bg-background-100 rounded-lg border border-background-200/70 p-6 md:p-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-primary-500 text-lg"></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">联系邮箱</h3>
                <p className="text-sm text-foreground-500">contact@aidou.tv</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-customer-service-2-line text-accent-600 text-lg"></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">在线客服</h3>
                <p className="text-sm text-foreground-500">工作日 9:00-18:00</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-feedback-line text-secondary-600 text-lg"></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">内容投稿</h3>
                <p className="text-sm text-foreground-500">submit@aidou.tv</p>
              </div>
            </div>
          </div>
          <p className="text-sm text-foreground-500 text-center leading-relaxed">
            如果您是综艺制作方或版权方，欢迎通过以上方式与我们取得联系。
            爱豆影视致力于为观众提供最优质的偶像综艺和真人秀高清免费在线观看服务，
            期待与更多优质内容方合作，共同打造不缓冲不卡顿的流畅播放体验。
          </p>
        </div>
      </div>
    </section>
  );
}